// Same lowercase names the mobile app sends as `device_os`, so panel and app
// traffic can be grouped together in the user journey data.
export function detectDeviceOs() {
  if (typeof navigator === "undefined") return undefined;

  const ua = (navigator.userAgent || "").toLowerCase();
  const platform = (navigator.userAgentData?.platform || navigator.platform || "").toLowerCase();

  // Android reports a Linux platform, so it has to be checked first.
  if (ua.includes("android")) return "android";
  // iPadOS 13+ presents itself as a Mac; touch points give it away.
  if (/iphone|ipad|ipod/.test(ua) || (platform.includes("mac") && navigator.maxTouchPoints > 1)) return "ios";
  if (platform.includes("win")) return "windows";
  if (platform.includes("mac")) return "macos";
  if (ua.includes("cros")) return "chromeos";
  if (platform.includes("linux")) return "linux";
  return undefined;
}
